import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import PutCallRatioFull from './put-call-ratio-full';

const PutCallRatioFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <PutCallRatioFull {...props} />
    </QueryClientProvider>
  );
};

export { PutCallRatioFullWidget }
